import PolandAnimatedMap from "@/components/PolandAnimatedMap";

/**
 * Podgląd animowanej mapy Polski (do decyzji: czy wdrożyć na stronę główną).
 * Otwórz: /mapa-podglad
 */
export default function MapPreview() {
  return (
    <div data-testid="map-preview" className="min-h-screen bg-gradient-to-br from-slate-950 via-[#0a1a3a] to-slate-900 py-16 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-cyan-300/60 text-xs uppercase tracking-widest font-bold mb-3">Podgląd animacji</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white mb-2">
          Nasza sieć w całej Polsce
        </h1>
        <p className="text-slate-300 mb-10">
          Łuki rysują się kolejno przez ~11 sekund, potem animacja startuje od nowa.
          Jeśli podoba Ci się efekt — dam znać i wdrożę to na stronie głównej zamiast statycznej mapy.
        </p>
        <div className="rounded-2xl bg-slate-900/60 border border-cyan-500/20 p-4 md:p-8 shadow-2xl shadow-cyan-500/10">
          <PolandAnimatedMap />
        </div>
        <p className="text-center text-slate-400 text-sm mt-6">
          11 miast · pętla 14 s · <span className="text-cyan-300">SVG + CSS</span> (żadnego video / GIF)
        </p>
      </div>
    </div>
  );
}
